var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-wrap", attrs: { id: "warnTip" } },
    [
      _c("svg-icon", {
        staticClass: "login-logo",
        attrs: { "icon-class": "icon_logo" },
      }),
      _vm.isWeixinBrowser
        ? _c("div", { staticClass: "warningTip" }, [
            _vm._v(
              "抱歉，暂不支持微信浏览器登录，请更换谷歌浏览器后，复制链接前往 " +
                _vm._s(_vm.provHostName)
            ),
            _c("i", {
              staticClass: "el-icon-document-copy y-c-p y-ml-5 systemColor",
              attrs: { title: "复制" },
              on: { click: _vm.copyKhgjUrlFn },
            }),
          ])
        : _c("div", { staticClass: "warningTip" }, [
            _vm._v("客户管家新登录地址 "),
            _c("a", { attrs: { href: _vm.provHostName } }, [
              _vm._v(_vm._s(_vm.provHostName)),
            ]),
            _c("span", { staticClass: "lastTip" }, [_vm._v("请点击前往")]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }